import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  img: {
    height: "35vh",
    width: "100%",
    objectFit: "cover"
  }
}));
